import { useEffect, useRef } from 'react';
import { useServiceStore } from './useServiceStore';
import { useRecipeStore } from './useRecipeStore';
import { useAuthStore } from '@/stores/useAuthStore';
import { SURFACE_RECIPES } from '../entities/recipe/data/initialData';

export const ServiceMigration = () => {
  const runMigration = useServiceStore((s) => s.runMigration);
  const { guestMode, authLoading } = useAuthStore();
  const migrationRan = useRef(false);

  useEffect(() => {
    // 1. Wait: auth session not yet resolved (ServiceMigration mounts before AuthInit —
    //    see AppProvider.tsx line 16 vs 18). Without this guard, runMigration() would
    //    run with stale guestMode:true even for logged-in users (Pitfall 3 / T-12-08).
    if (authLoading) return;

    // 2. Prevent double-run across effect re-evaluations (e.g. authLoading flip).
    if (migrationRan.current) return;
    migrationRan.current = true;

    // 3. Self-healing nameKey only for confirmed guests.
    //    For logged-in users, applyServerOverrides() (Phase 12 CAT-01) is the authoritative
    //    source for names/prices — running runMigration() would overwrite server names with
    //    SERVICES_DB defaults (T-12-08 mitigation).
    if (guestMode) {
      runMigration();
    }

    // 4. Recipe seeding: guestMode-independent — both guest and logged-in users need
    //    SURFACE_RECIPES when the store is empty (e.g. first launch / cleared storage).
    const recipes = useRecipeStore.getState().recipes;
    const totalRecipes = Object.values(recipes).flat().length;
    if (totalRecipes === 0) {
      useRecipeStore.setState({ recipes: SURFACE_RECIPES });
    }
  }, [runMigration, guestMode, authLoading]);

  return null;
};